import * as React from 'react';
import { TextInput } from "soprasteria-ui-library";
import { formatCurrency } from '../../../helpers/CurrencyHelper';

interface IRiskPotReportBudgetOverview {
    billableAmount: number;
    invoicedAmount: number;
}

export const RiskPotReportBudgetOverview: React.FunctionComponent<IRiskPotReportBudgetOverview> = ({ billableAmount, invoicedAmount }) => {

    return (
        <>
            <hr />
            <section className="row">
                <div className="col-9">
                </div>
                <div className="col-3 readonly-less-margin">
                    <div className="border p-2">
                        <h5>Totalbelopp</h5>
                        <TextInput name="billableAmountReadonly" label="Fakturerbart belopp" defaultValue={`${formatCurrency(billableAmount)}`} inlineLabel readonly labelCol={7} inputCol={5} />
                        <TextInput name="invoicedAmount" label="Fakturerat belopp" defaultValue={`${formatCurrency(invoicedAmount)}`} inlineLabel readonly labelCol={7} inputCol={5} />
                    </div>
                </div>
            </section>
        </>
    )

}